import { ReduxAction } from 'app/redux/types';

// ---

export const OPEN_ALL_ENTITIES = 'MY_STAKES:OPEN_ALL_ENTITIES';

export type OpenAllEntities = ReduxAction<typeof OPEN_ALL_ENTITIES, number[]>;

export const openAllEntities = (payload: number[]): OpenAllEntities => ({
  type: OPEN_ALL_ENTITIES,
  payload,
});

// ---

export const CLOSE_ALL_ENTITIES = 'MY_STAKES:CLOSE_ALL_ENTITIES';

export type CloseAllEntities = ReduxAction<typeof CLOSE_ALL_ENTITIES, number[]>;

export const closeAllEntities = (payload: number[]): CloseAllEntities => ({
  type: CLOSE_ALL_ENTITIES,
  payload,
});

// ---

type StakeIds = number | number[];

export const CLOSE_ENTITY = 'MY_STAKES:CLOSE_ENTITY';

export type CloseEntity = ReduxAction<typeof CLOSE_ENTITY, {
  ids: StakeIds;
}>;

export const closeEntity = (ids: StakeIds): CloseEntity => ({
  type: CLOSE_ENTITY,
  payload: { ids },
});

// ---

export const OPEN_ENTITY = 'MY_STAKES:OPEN_ENTITY';

export type OpenEntity = ReduxAction<typeof OPEN_ENTITY, {
  ids: StakeIds;
}>;

export const openEntity = (ids: StakeIds): OpenEntity => ({
  type: OPEN_ENTITY,
  payload: { ids },
});
